import { render, staticRenderFns } from "./hospitaltender.vue?vue&type=template&id=8c3a9792"
import script from "./hospitaltender.vue?vue&type=script&lang=js"
export * from "./hospitaltender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports